import type { FormFunnelFlowScreen } from "@portal/app/_components/formFunnel/types";
import { isPageContentVisible, pageVisibilityPhase } from "./pageVisibility";
import type { PuckBlockProps, PuckLandingPageData } from "./types";

/** The form supplies a primary heading when no currently visible page block does. */
export function hasVisiblePageHeading(
  data: PuckLandingPageData,
  flow: Pick<FormFunnelFlowScreen, "flowState" | "isFirstQuestionStep">
): boolean {
  const phase = pageVisibilityPhase(flow.flowState);
  const pending: unknown[] = [...data.content];
  while (pending.length) {
    const value = pending.pop();
    if (!value || typeof value !== "object" || Array.isArray(value)) continue;
    const item = value as { type?: string; props?: Record<string, unknown> };
    if (!item.props) continue;
    if (
      item.type === "Visibility" &&
      !isPageContentVisible(
        item.props.when as PuckBlockProps["Visibility"]["when"],
        phase,
        flow.isFirstQuestionStep
      )
    )
      continue;
    if (
      item.type === "Heading" &&
      item.props.level === 1 &&
      typeof item.props.text === "string" &&
      item.props.text.trim()
    )
      return true;
    // RichText renders authored H1s as H2s, so it cannot supply the page's H1.
    for (const children of Object.values(item.props)) {
      if (Array.isArray(children)) pending.push(...children);
    }
  }
  return false;
}
